import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Dashboard is usually the landing page — "Go Back" has nowhere useful to go,
// so offer Logout instead when it's the restricted module.
const AccessDenied = ({ module = '' }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const isDashboard = module?.toLowerCase() === 'dashboard';
  return (
    <div style={{
      display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
      minHeight:'60vh', fontFamily:"'Sora',sans-serif", textAlign:'center', padding:'2rem',
    }}>
      <div style={{fontSize:'3.5rem', marginBottom:'1rem'}}>🔒</div>
      <div style={{fontSize:'1.3rem', fontWeight:700, color:'#0f1123', marginBottom:8}}>
        Access Restricted
      </div>
      <div style={{fontSize:'.88rem', color:'#9094a8', maxWidth:360, lineHeight:1.6, marginBottom:'1.5rem'}}>
        You don't have permission to access{module ? ` "${module}"` : ' this module'}.
        Please contact your administrator to request access.
      </div>
      {isDashboard ? (
        <button onClick={() => { logout(); navigate('/login'); }}
          style={{
            display:'inline-flex', alignItems:'center', gap:7, padding:'10px 20px',
            background:'#fef2f2', color:'#ef4444', border:'1px solid #fecaca', borderRadius:10,
            fontFamily:"'Sora',sans-serif", fontSize:'.82rem', fontWeight:600, cursor:'pointer',
          }}>
          Logout
        </button>
      ) : (
        <button onClick={() => navigate(-1)}
          style={{
            display:'inline-flex', alignItems:'center', gap:7, padding:'10px 20px',
            background:'#3b6ef8', color:'white', border:'none', borderRadius:10,
            fontFamily:"'Sora',sans-serif", fontSize:'.82rem', fontWeight:600, cursor:'pointer',
          }}>
          ← Go Back
        </button>
      )}
    </div>
  );
};

export default AccessDenied;